:host {
  display: contents;
}

.br-table-body {
  display: contents;
}
